import React from 'react';
import { Wrapper } from './EventHeader.styles';
import iconCalendar from '../../../assets/icon-calendar.svg';
import { useBaseScreenHook } from '../../../logic/core/base-screen.hook';
import { EventModel, EventType, MeetingStatus } from '../../../logic/events/events.model';
import { Organization } from '../../../logic/organizations/organizations.model';

const EventHeader = ({event, organization}: {event: EventModel, organization: Organization}) => {
    const {i18n, t} = useBaseScreenHook();
    const dateFormatter = new Intl.DateTimeFormat(i18n.language, {
        dateStyle: 'short',
        timeStyle: 'short'
    }).format;

    const renderDate = () => {
        const basic = event?.content?.basic;
        if (!basic) return null;

        if (event?.content?.type === EventType.CIRCULAR) {
            const hasStart = !!basic.startDate;
            const hasFinish = !!basic.finishDate;

            return (
                <div className="date-items">
                    {hasStart ? (
                        <span className="date-item start-item">
                            <img src={iconCalendar} alt="icon" />
                            <span>{t('eventHeader.start')}: {dateFormatter(new Date(basic.startDate!))}</span>
                        </span>
                    ) : null}
                    {hasFinish ? (
                        <span className="date-item finish-item">
                            <img className="red-icon" src={iconCalendar} alt="icon" />
                            <span className="finish-text">{t('eventHeader.finish')}: {dateFormatter(new Date(basic.finishDate!))}</span>
                        </span>
                    ) : null}
                </div>
            );
        }

        return basic.startDate ? (
            <span className="date-item">
                <img src={iconCalendar} alt="icon" />
                <span>{dateFormatter(new Date(basic.startDate))}</span>
            </span>
        ) : null;
    };

    return <Wrapper>
        <div className="title">
            {event?.content?.basic.name}
        </div>

        <div className="description">
            {t('eventInfo.description', {
                organizationName: organization.name,
                eventName: event?.content?.basic.body.name,
            })}
        </div>

        <div className="date">
            {renderDate()}
        </div>
    </Wrapper>
}

export default EventHeader;
